import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

try {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
  
} catch (error) {
  console.error('React initialization failed:', error);
  
  // Show error on fallback page
  const message = document.getElementById('fallback-message');
  if (message) {
    message.innerHTML = 
      '<strong>Application failed to initialize.</strong><br><br>' +
      'Please try updating your browser or contact support.<br><br>' +
      '<a href="javascript:location.reload()">Reload Page</a>';
  }
}
